import { useEffect } from "react";
import { useTelegram } from "../telegram/TelegramProvider";
import { setApiIdentity } from "../api/client";

/** Wires the resolved Telegram/anonymous identity into the API client's outgoing headers. */
export function IdentitySync() {
  const { initDataRaw, anonymousId } = useTelegram();
  useEffect(() => {
    setApiIdentity({ initDataRaw, anonymousId });
  }, [initDataRaw, anonymousId]);
  return null;
}
